<template>
  <transition :name="fadeIn">
    <div
      class="toast-alert"
      v-if="show"
    >
      <div
        class="toast-mask"
        v-if="isShowMask"
      ></div>
      <transition :name="translate">
        <div
          class="toast-box"
          :class="position"
          v-if="show"
        >
          <!-- <img :src="img.favImg" alt="" class="favImg"> -->
          <p>{{text}}</p>
          <!-- <p class="ui-content">{{content}}</p> -->
        </div>
      </transition>
    </div>
  </transition>
</template>
 
<script>
export default {
  props: {
    show: {
      default: false
    },
    text: {
      default: ''
    },
    content: {
      default: 'loading...'
    },
    position: {
      default: 'center'
    },
    isShowMask: {
      default: false
    },
    t: {
      default: 2500
    },
    transition: {
      default: true
    }
  },
  data() {
    return {
      img: {
        favImg: require('../../assets/wjx.png')
      }
    };
  },
  methods: {
    hideToast() {
      setTimeout(() => {
        this.show = false;
      }, this.t);
    }
  },
  computed: {
    translate() {
      if (!this.transition) {
        return '';
      } else {
        if (this.position === 'top') {
          return 'translate-top';
        } else if (this.position === 'middle') {
          return 'translate-middle';
        } else if (this.position === 'bottom') {
          return 'translate-bottom';
        }
      }
    },
    fadeIn() {
      if (!this.transition) {
        return '';
      } else {
        return 'fadeIn';
      }
    }
  },
  watch: {
    show: {
      handler(newValue) {
        newValue && this.hideToast();
      },
      deep: true
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/mixin.scss';

.toast-box {
  width: 100% !important;
  //width: $rem400;
  //height: $rem80;
  position: fixed;
  top: $rem198;
  left: 50%;
  transform: translateX(-50%);
  //margin-left: -$rem400/2;
  //margin-top: -$rem80/2;
  //text-align: center;
  //line-height: 100px;
  color: #fff;
  z-index: 5000;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  //box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  //border-radius: 100px;
  p {
    font-family: PingFangSC-Regular;
    color: #ffffff;
    letter-spacing: 0;
    font-size: $rem24;
    //display: block;
    height: $rem24 !important;
    line-height: $rem24;
    padding: $rem16 $rem26;
    box-sizing: content-box !important;
    border-radius: $rem28 !important;
    //border-radius: 50%;
    background: rgba(194, 148, 81, 0.9);
    width: auto !important;
    flex-shrink: 0 !important;
  }
}
.ui-content {
  height: $rem100;
  line-height: $rem100;
}
.toast-mask {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 4999;
}
.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: opacity 0.3s;
}
.fadeIn-enter,
.fadeIn-leave-active {
  opacity: 0;
}
.translate-top-enter-active,
.translate-top-leave-active {
  transition: all 0.3s cubic-bezier(0.36, 0.66, 0.04, 1);
}
.translate-top-enter,
.translate-top-leave-active {
  transform: translateY(-50%);
  opacity: 0;
}
.translate-middle-enter-active,
.translate-middle-leave-active {
  transition: all 0.3s cubic-bezier(0.36, 0.66, 0.04, 1);
}
.translate-middle-enter,
.translate-middle-leave-active {
  transform: translateY(80%);
  opacity: 0;
}
.translate-bottom-enter-active,
.translate-bottom-leave-active {
  transition: all 0.3s cubic-bezier(0.36, 0.66, 0.04, 1);
}
.translate-bottom-enter,
.translate-bottom-leave-active {
  transform: translateY(100%);
  opacity: 0;
}
.favImg {
  width: $rem84;
  height: $rem84;
}
</style>
